export default {
    procurementsList: 'Kiküldetési kérelmek',
    coordinationList: 'Kiküldetési kérelem beszerzés koordináció',
    countersignationList: 'Kiküldetési kérelem ellenjegyzés',
    liabilityList: 'Kiküldetési kérelem kötelezettségvállalás'
};
